module.exports = __webpack_public_path__ + "img/GrandPrizeGame.2cd0ad92.png";